import { trackSuccessAttempt, } from '../../common/buildPayloadsTyped/trackSuccessAttempt.js';
export const trackFacebookAttemptSuccessfulRequest = (params) => {
    return trackSuccessAttempt({ ...params, loginMethod: 'facebook' });
};
//# sourceMappingURL=trackFacebookAttemptSuccessfulRequest.js.map